import React from 'react';
import TabView from "../../lotto/TabView";
import LottoBettingBoardMobile from "../../betting/mobile/LottoBettingBoardMobile";
import {useLotto99} from "../../../store/lotto99/Lotto99Context";
import MobileDashboardDrawingLotto99 from "./MobileDashboardDrawingLotto99";
import RecentTicketMobile from "./RecentTicketMobile";
import "../../../assets/css/lotto99mobile.css"
import ResultHistoryMobile from "./ResultHistoryMobile";

const Sale = () => {

    const {t} = useLotto99()

    const tabs = [
        t("labels:drawing.betting"),
        t("labels:drawing.result")
    ];
    const children = [
        <RecentTicketMobile/>,
        <ResultHistoryMobile/>
    ]

    return (
        <div id="lotto90-mobile">
            <div className="betting-board lotto90">
                <div className="m-0">
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <MobileDashboardDrawingLotto99/>
                            <LottoBettingBoardMobile
                                useHook={useLotto99}
                                priceKey="lotto99PackagePrices"
                                wrapperClass="lotto90-mobile-board"
                            />
                            <div className="tab-view border-all mt-2 num-pad-btn">
                                <TabView children={children} tabs={tabs}/>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Sale;